import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { CommonPaymentRequest } from "./paymentRequest"

export type CreatePaymentRequestRequest = {
  customer: {
    name: string
    email: string | null
    phone: string | null
  }
  description: string
  vatCode: "T0" | "T1" | "T2" | "T5"
  amountNet: number
  customerCreated: boolean
}

export const createPaymentRequest = async (
  params: CreatePaymentRequestRequest
) => {
  const { body } = await api.post<
    RecursivelyConvertDatesToStrings<CommonPaymentRequest>
  >("/services/payments/", { body: params })

  queryClient.invalidateQueries([
    PAYMENT_REQUESTS_QUERY_KEY,
  ])

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
    lastSentAt: body.lastSentAt
      ? DateFns.parseISO(body.lastSentAt)
      : null,
  }
}
